export default {
  state: () => {
    return {
      messages: [],
    }
  },

  getters: {
    messages(state): string[] {
      return state.messages
    },
  },

  mutations: {
    errorMessage(state, value): void {
      state.messages.push(value)
    },
    successMessage(state, value): void {
      state.messages.push({
        extensions: {
          status: 200,
        },
        message: value,
      })
    },
  },

  actions: {
  },
}
